// The retake attempts cap (`settings.attempts_no`): one source for the range
// the deliver form offers, the clamp the wire carries, and the select options.
// Consumers must not restate 2 or 10.

/** Fewest retakable attempts. Legacy rows hold 1, which is not offered. */
export const ATTEMPTS_NO_MIN = 2;
/** Most attempts the product allows — there is no unlimited option. */
export const ATTEMPTS_NO_MAX = 10;

/** Cap held inside the range the deliver select offers. Legacy rows hold 1,
 *  which the select shows — and the wire ships — as the minimum. */
export const attemptsCap = (value: unknown): number => {
  const attemptsNo = Math.trunc(Number(value));
  if (!Number.isFinite(attemptsNo) || attemptsNo < ATTEMPTS_NO_MIN) return ATTEMPTS_NO_MIN;
  return Math.min(attemptsNo, ATTEMPTS_NO_MAX);
};

/** Deliver-form select options, min..max as strings. */
export const ATTEMPTS_NO_OPTIONS = Array.from(
  { length: ATTEMPTS_NO_MAX - ATTEMPTS_NO_MIN + 1 },
  (_, i) => ({ value: String(i + ATTEMPTS_NO_MIN), label: String(i + ATTEMPTS_NO_MIN) })
);
